import { createApi } from '@reduxjs/toolkit/query/react'

import { baseApi } from './utils'
import { BulkVehicleOrderDashboardFetch } from '../../components/BulkVehicleOrder/types'

export const bulkVehicleOrderApi = createApi({
	reducerPath: 'bulkVehicleOrder',
	...baseApi('/bulk-vehicle-order/'),
	endpoints: builder => ({
		getDashboard: builder.query<BulkVehicleOrderDashboardFetch, void>({
			query: () => 'dashboard/',
		}),
	}),
})

export const { useGetDashboardQuery } = bulkVehicleOrderApi
